export default {
  AiCall: {
    Connecting: 'Connecting...',
    AISpeaking: 'Interviewer is speaking',
    AIListening: 'Interviewer is listening',
    ReadyToStart: 'Ready to start',
    Duration: 'Call Duration: #{duration}',
    StartCall: 'Start Call',
    callEnded: 'Call Ended',
  },
};
